import React, { Component } from 'react';
import './footer.scss';
import {Event} from '../common/event';


export default class Footer extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
        <div className="footer">
          <button className="round" onClick={this.toggle.bind(this)}>
            切换
          </button>
        </div>
    );
  }

  toggle() {
    Event.emit('ShowRight',2);
  }
}